import * as firebase from "firebase";
import { getField, updateField } from 'vuex-map-fields';

function sortCards(cardA, cardB) {
    if (parseInt(cardA.metadata.setInfo.year) < parseInt(cardB.metadata.setInfo.year)) {
        return 1;
    }
    if (parseInt(cardA.metadata.setInfo.year) > parseInt(cardB.metadata.setInfo.year)) {
        return -1;
    }
    if (cardA.name.toLowerCase() < cardB.name.toLowerCase()) {
        return -1;
    }
    if (cardA.name.toLowerCase() > cardB.name.toLowerCase()) {
        return 1;
    }
    return 0;
}

export default {
    strict: true,
    state: {
        error: null,

        // card viewer filters
        filterValues: {
            starAbilityFilter: false,
            cardNumberFilter: null,
            nameFilter: "",
            specialAbilityFilter: "",
            identifierFilter: "",
            setFilterList: [],
            alignmentFilterList: [],
            bookFilterList: [],
            brigadeFilterList: [],
            classFilterList: [],
            rarityFilterList: [],
            typeFilterList: [],
        },
        // user auth
        user: null,
        loading: false,
        isUserLoggedIn: false,

        // user indicators
        loginSnackbar: false,
        logoutSnackbar: false,
        registrationSnackbar: false,

        // cards page
        showFilterDrawer: false,

        // cards
        cardData: [],
        dictionaryData: [],
        setList: [],
        rarityList: [],
        alignmentList: [],
        classList: [],
        typeList: [],
        bookList: [],
        brigadeList: [],
        ntBookList: [],
        otBookList: [],
    },
    getters: {
        getField,

        getShowFilterDrawer: state => {
            return state.showFilterDrawer;
        },
        getCards: state => {
            return state.cardData;
        },
        //gets a card by ID
        getCardById: (state, getters) => (cardID) => {
            return getters.getCards.find(card => card.id === cardID);
        },
        //gets all cards in the array of cardIDs
        getCardsById: (state, getters) => (cardIDs) => {
            return getters.getCards.filter(card => cardIDs.includes(card.id));
        },
        getSetList: state => {
            return state.setList;
        },
        getAlignmentList: state => {
            return state.alignmentList;
        },
        getClassList: state => {
            return state.classList;
        },
        getRarityList: state => {
            return state.rarityList;
        },
        getTypeList: state => {
            return state.typeList;
        },
        getBookList: state => {
            return state.bookList;
        },
        getBrigadeList: state => {
            return state.brigadeList;
        },
        getDictionaries: state => {
            return state.dictionaryData;
        },
        getFilteredCards: (state, getters) => {
            // start with all cards in the pot
            let filterValues = state.filterValues;
            let returnCards = getters.getCards;

            // narrow down pool
            if (filterValues.nameFilter !== "" && filterValues.nameFilter !== null) {
                returnCards = getters.getCardsByName(filterValues.nameFilter, returnCards);
            }
            if (filterValues.specialAbilityFilter !== "" && filterValues.specialAbilityFilter !== null) {
                returnCards = getters.getCardsBySpecialAbility(filterValues.specialAbilityFilter, returnCards);
            }
            if (filterValues.setFilterList.length > 0) {
                returnCards = getters.getCardsBySet(filterValues.setFilterList, returnCards);
            }
            if (filterValues.identifierFilter !== "" && filterValues.identifierFilter !== null) {
                returnCards = getters.getCardsByIdentifier(filterValues.identifierFilter, returnCards);
            }
            if (filterValues.brigadeFilterList.length > 0) {
                returnCards = getters.getCardsByBrigade(filterValues.brigadeFilterList, returnCards);
            }
            if (filterValues.classFilterList.length > 0) {
                returnCards = getters.getCardsByClass(filterValues.classFilterList, returnCards);
            }
            if (filterValues.typeFilterList.length > 0) {
                returnCards = getters.getCardsByType(filterValues.typeFilterList, returnCards);
            }
            if (filterValues.alignmentFilterList.length > 0) {
                returnCards = getters.getCardsByAlignment(filterValues.alignmentFilterList, returnCards);
            }
            if (filterValues.bookFilterList.length > 0) {
                returnCards = getters.getCardsByBook(filterValues.bookFilterList, returnCards);
            }
            if (filterValues.rarityFilterList.length > 0) {
                returnCards = getters.getCardsByRarity(filterValues.rarityFilterList, returnCards);
            }

            if (filterValues.cardNumberFilter) {
                returnCards = getters.getCardsByCardNumber(filterValues.cardNumberFilter, returnCards);
                console.log(returnCards)
            }

            if (filterValues.starAbilityFilter) {
                console.log(filterValues.starAbilityFilter)
                returnCards = getters.getStarCards(returnCards);
            }

            //TODO: remove duplicates here eventually
            return returnCards.sort(sortCards);
        },
        getCardsBySet: (state) => (setList, cards) => {
            let returnList = [];
            cards.forEach(card => {
                let cardSetName = state.dictionaryData["sets"][card.set].name;
                if (state.dictionaryData["sets"][card.set].subset !== undefined) {
                    cardSetName = cardSetName + " (" + state.dictionaryData["sets"][card.set].subset + ")";
                }
                setList.forEach(setName => {
                    if (cardSetName === setName) {
                        returnList.push(card);
                    }
                });
            });
            return returnList;
        },
        getCardsByRarity: () => (rarityList, cards) => {
            let returnList = [];
            cards.forEach(card => {
                let added = false;
                rarityList.forEach(() => {
                    if (rarityList.includes(card.rarity) && !added) {
                        returnList.push(card);
                        added = true;
                    }
                });
            });
            console.log(returnList);
            return returnList;
        },
        getCardsByBrigade: () => (brigadeList, cards) => {
            let returnList = [];
            cards.forEach(card => {
                if (card.brigades !== undefined) {
                    let cardBrigades = card.brigades;
                    if (card.secondSide !== undefined) {
                        if (card.secondSide.brigades !== undefined) {
                            cardBrigades = cardBrigades.concat(card.secondSide.brigades);
                        }
                    }
                    let hasAll = true;
                    brigadeList.forEach(brigade => {
                        if (!cardBrigades.includes(brigade)) {
                            hasAll = false;
                        }
                    });
                    if (hasAll) {
                        returnList.push(card);
                    }
                }
            });
            return returnList;
        },
        getCardsByClass: () => (classList, cards) => {
            let returnList = [];
            cards.forEach(card => {
                if (card.classes !== undefined) {
                    let cardClasses = card.classes;
                    if (card.secondSide !== undefined) {
                        if (card.secondSide.classes !== undefined) {
                            cardClasses = cardClasses.concat(card.secondSide.classes);
                        }
                    }
                    let hasAll = true;
                    classList.forEach(brigade => {
                        if (!cardClasses.includes(brigade)) {
                            hasAll = false;
                        }
                    });
                    if (hasAll) {
                        returnList.push(card);
                    }
                }
            });
            return returnList;
        },
        getCardsByName: () => (name, cards) => {
            return cards.filter(function (card) {
                if (card.metadata !== undefined && card.metadata.compositeName !== undefined) {
                    return card.metadata.compositeName.toLowerCase().includes(name.toLowerCase());
                } else {
                    return card.name.toLowerCase().includes(name.toLowerCase())
                }
            });
        },
        getCardsBySpecialAbility: () => (specialAbility, cards) => {
            return cards.filter(function (card) {
                if (card.specialAbility !== undefined) {
                    let cardSpecialAbility = card.specialAbility;
                    if (card.secondSide !== undefined) {
                        if (card.secondSide.specialAbility !== undefined) {
                            cardSpecialAbility = cardSpecialAbility.concat(card.secondSide.specialAbility);
                        }
                    }
                    return cardSpecialAbility.toLowerCase().includes(specialAbility.toLowerCase());
                }
            });
        },
        getCardsByIdentifier: () => (identifier, cards) => {
            let returnList = [];
            cards.forEach((card) => {
                if (card.identifiers !== undefined) {
                    let cardIdentifiers = card.identifiers;
                    if (card.secondSide !== undefined) {
                        if (card.secondSide.identifiers !== undefined) {
                            cardIdentifiers = cardIdentifiers.concat(card.secondSide.identifiers);
                        }
                    }
                    let added = false;
                    cardIdentifiers.forEach(cardIdentifier => {
                        if (cardIdentifier.toLowerCase().includes(identifier.toLowerCase()) && !added) {
                            returnList.push(card);
                            added = true;
                        }
                    });
                }
            });
            return returnList;
        },
        getCardsByType: () => (typeList, cards) => {
            let returnList = [];
            cards.forEach((card) => {
                let cardTypes = [];
                cardTypes.push(card.type);
                if (card.secondSide !== undefined) {
                    cardTypes.push(card.secondSide.type);
                }
                let hasAll = true;
                typeList.forEach(type => {
                    if (!cardTypes.includes(type)) {
                        hasAll = false;
                    }
                });
                if (hasAll) {
                    returnList.push(card);
                }
            });
            return returnList;
        },
        getCardsByAlignment: () => (alignmentList, cards) => {
            let returnList = [];
            cards.forEach((card) => {
                let cardAlignments = [];
                cardAlignments.push(card.alignment);
                if (card.secondSide !== undefined) {
                    cardAlignments.push(card.secondSide.alignment);
                }
                let hasAll = true;
                alignmentList.forEach(type => {
                    if (!cardAlignments.includes(type)) {
                        hasAll = false;
                    }
                });
                if (hasAll) {
                    returnList.push(card);
                }
            });
            return returnList;
        },
        getCardsByBook: () => (bookList, cards) => {
            let returnList = [];
            cards.forEach((card) => {
                if (card.reference !== undefined && card.reference[0] !== undefined) {
                    let cardBooks = [];
                    cardBooks.push(card.reference[0].book);
                    if (card.secondSide !== undefined) {
                        if (card.secondSide.reference !== undefined && card.secondSide.reference[0] !== undefined) {
                            cardBooks.push(card.secondSide.reference[0].book);
                        }
                    }
                    let hasAll = true;
                    bookList.forEach(type => {
                        if (!cardBooks.includes(type)) {
                            hasAll = false;
                        }
                    });
                    if (hasAll) {
                        returnList.push(card);
                    }
                }
            });
            return returnList;
        },
        getStarCards: () => (cards) => {
            console.log("called get star cards")
            console.log(cards)
            let returnList = [];
            cards.forEach((card) => {
                if (card.starAbility !== undefined) {
                    console.log("card has star ability")
                    returnList.push(card)
                } else if (card.secondSide !== undefined) {
                    if (card.secondSide.starAbility !== undefined) {
                        returnList.push(card);
                    }
                }
            });
            return returnList;
        },
        getCardsByCardNumber: () => (number, cards) => {
            console.log("called get cards by number")
            console.log(cards)
            let returnList = [];
            cards.forEach((card) => {
                if (card.cardNumber !== undefined) {
                    if (card.cardNumber === number) {
                        console.log("card has number")
                        returnList.push(card)
                    }
                }
            });
            return returnList;
        },
    },
    mutations: {
        updateField,

        setShowFilterDrawer: (state, value) => state.showFilterDrawer = value,

        SET_CARD_DATA: (state, cards) => state.cardData = cards,

        SET_DICTIONARY_DATA: (state, dictionaries) => state.dictionaryData = dictionaries,

        SET_SET_LIST_DATA: (state, setList) => state.setList = setList,

        SET_ALIGNMENT_LIST_DATA: (state, alignmentList) => state.alignmentList = alignmentList,

        SET_BOOK_LIST_DATA: (state, bookList) => state.bookList = bookList,

        SET_BRIGADE_LIST_DATA: (state, brigadeList) => state.brigadeList = brigadeList,

        SET_CLASS_LIST_DATA: (state, classList) => state.classList = classList,

        SET_RARITY_LIST_DATA: (state, rarityList) => state.rarityList = rarityList,

        SET_TYPE_LIST_DATA: (state, typeList) => state.typeList = typeList,
    },
    actions: {
        toggleFilterDrawer({commit}) {
            commit("setShowFilterDrawer", !commit.showFilterDrawer);
        },

        initializeCardData: async context => {
            firebase.firestore().collection("dictionaries").get().then((snapshot) => {
                const dictionaries = {};

                snapshot.forEach(doc => {
                    dictionaries[doc.id] = doc.data();
                });
                console.log("initialized dictionaries");
                console.log(dictionaries);
                context.commit('SET_DICTIONARY_DATA', dictionaries);

                // create set abbreviation list
                let setList = [];
                Object.keys(context.state.dictionaryData["sets"]).forEach((setID) => {
                    let setName = context.state.dictionaryData["sets"][setID].name;
                    if (context.state.dictionaryData["sets"][setID].subset !== undefined) {
                        setName = setName + " (" + context.state.dictionaryData["sets"][setID].subset + ")"
                    }
                    setList.push(setName);
                });

                console.log("initialized set list");
                setList.sort();
                console.log(setList);
                context.commit('SET_SET_LIST_DATA', setList);

                context.commit('SET_ALIGNMENT_LIST_DATA', context.state.dictionaryData["misc"]["alignmentList"]);

                context.commit('SET_BOOK_LIST_DATA', context.state.dictionaryData["misc"]["bookList"]);

                context.commit('SET_BRIGADE_LIST_DATA', context.state.dictionaryData["misc"]["brigadeList"]);

                context.commit('SET_CLASS_LIST_DATA', context.state.dictionaryData["misc"]["classList"]);

                context.commit('SET_RARITY_LIST_DATA', context.state.dictionaryData["misc"]["rarityList"]);

                context.commit('SET_TYPE_LIST_DATA', context.state.dictionaryData["misc"]["typeList"]);

            });

            firebase.firestore().collection("cards").get().then((snapshot) => {
                const cards = [];

                snapshot.forEach(doc => {
                    let docCards = doc.data();
                    // combines the set ordered cards into a single list of cards
                    Object.keys(docCards).forEach((cardID) => {
                        cards.push(docCards[cardID]);
                    });
                });

                // add card metadata

                cards.forEach((card) => {
                    // initialize metadata object
                    card["metadata"] = {};

                    // add set data from dictionary
                    card["metadata"]["setInfo"] = context.state.dictionaryData["sets"][card["set"]];

                    let name = card["name"];
                    if (card["secondSide"] !== undefined) {
                        if (card["secondSide"]["name"] !== undefined && card["secondSide"]["name"] !== name) {
                            card["metadata"]["compositeName"] = name + " / " + card["secondSide"]["name"];
                        }
                    }


                    // add image link (SHOULD NOT BE NEEDED NOW)
                    card["metadata"]["imageLink"] = context.state.dictionaryData.misc.imageBase + card.imageName + ".jpg";

                });

                // finished adding card metadata

                console.log("initialized cards");
                console.log(cards);
                context.commit('SET_CARD_DATA', cards);
            });
        },
    },
};
